import React from 'react';

type LoginButtonProps = { handleClick?: () => void; children: React.ReactNode };

const LoginButton = ({ children, handleClick }: LoginButtonProps) => {
	return (
		<button
			className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-transparent b--transparent c-action-primary hover-b--transparent hover-bg-action-secondary hover-b--action-secondary pointer "
			type="button"
			onClick={() => handleClick && handleClick()}
		>
			{children}
		</button>
	);
};

export default LoginButton;
